var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Adicionar_compras",
    "data-name": "Adicionar compras",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 65.444,
    viewBox: "0 0 73 65.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1028",
    "data-name": "Caminho 1028",
    d: "M0,3.068A3.06,3.06,0,0,1,3.068,0H8.883a7.159,7.159,0,0,1,6.468,4.09H67.885a5.11,5.11,0,0,1,4.934,6.442L67.578,30a9.217,9.217,0,0,1-8.883,6.813H21.819l.69,3.643a3.079,3.079,0,0,0,3.017,2.492H62.376a3.068,3.068,0,0,1,0,6.135H25.526a9.193,9.193,0,0,1-9.037-7.477L9.893,6.966a1.017,1.017,0,0,0-1.01-.831H3.068A3.06,3.06,0,0,1,0,3.068ZM16.361,59.308A6.135,6.135,0,1,1,22.5,65.444,6.135,6.135,0,0,1,16.361,59.308Zm42.948-6.135a6.135,6.135,0,1,1-6.135,6.135A6.135,6.135,0,0,1,59.308,53.173Zm-27.1-32.722a2.564,2.564,0,0,0,2.556,2.556h5.624v5.624a2.556,2.556,0,0,0,5.113,0V23.008h5.624a2.556,2.556,0,0,0,0-5.113H45.5V12.271a2.556,2.556,0,1,0-5.113,0v5.624H34.767A2.564,2.564,0,0,0,32.211,20.451Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.ad91c86ec74ec93201292139de04e2bb.svg";
export { ForwardRef as ReactComponent };